export default __webpack_public_path__ + "static/media/rolling.ede895a3.jpeg";